import React from "react";
import { SwipeableDrawer } from "@material-ui/core";
import UnmountDrawerWrapper from "./UnmountDrawerWrapper";
import DrawerHeader from "./DrawerHeader";

interface IDrawerComponent {
  children: React.ReactNode;
  isOpen: boolean;
  closeDrawer: () => void;
  instructions?: string[]; //First item is regular, second is bold.
  title?: string;
}

const DrawerComponent = (props: IDrawerComponent) => {
  return (
    <SwipeableDrawer
      anchor={"bottom"}
      open={props.isOpen}
      onClose={props.closeDrawer}
      onOpen={() => null}
      disableSwipeToOpen={true}
      disableDiscovery={true}
      transitionDuration={350}
      id="CardDetailsDrawer"
      style={{ borderRadius: "16px" }}
      PaperProps={{ square: false, style: { borderRadius: "24px 24px 0 0" } }}
    >
      <UnmountDrawerWrapper closeDrawer={props.closeDrawer}>
        <>
          <DrawerHeader
            onClose={props.closeDrawer}
            title={props.title}
            instructions={props.instructions}
          />
          {props.children}
        </>
      </UnmountDrawerWrapper>
    </SwipeableDrawer>
  );
};

export default DrawerComponent;
